
import Vue from 'vue';
import OeamtcSelect, { OeamtcSelectValue } from '@components/new-styleguide/form/OeamtcSelect.vue';
import { Component, Prop } from 'vue-property-decorator';
import { Zone } from '@clients/myTrips';
import { ZoneWithRules } from '@/models/SettingsModels';
import { zoneIcons } from '@util/settingIcons'

@Component({
  name: 'ZoneSelect',
  components: {
    OeamtcSelect
  }
})
export default class ZoneSelect extends Vue {
  @Prop()
  private value: Zone;

  @Prop({ required: true })
  private zones: ZoneWithRules[];

  @Prop({ default: false })
  private disabled: boolean;

  private handleInput(index: number) {
    if (index === 0) {
      this.$emit('input', undefined);
    } else {
      this.$emit('input', this.zones[index - 1]);
    }
  }

  get valueIndex() {
    if (!this.value) {
      return 0;
    }

    return this.zones.findIndex(zone => zone.id === this.value.id) + 1;
  }

  get zoneOptions(): OeamtcSelectValue[] {
    const mappedZones = this.zones.map(zone => {
      const icon = zoneIcons(zone)
      icon.tagIcon.position = 7
      if (icon.letterIcon) {
        icon.letterIcon.position = 14
      }

      return {
        name: zone.name,
        ...icon
      }
    });

    return [{ name: 'Keine Auswahl' }, ...mappedZones];
  }
}
